import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import styles from './css/Questionnaire.styl';
import {FormControls} from '../../../../shared/library';
import {getName} from '../../../../../appModules/utilities/formatHelpers';
import {
  HeartIcon,
  InfoIcon,
  CloseXIcon,
  UGCSearchIcon,
} from '../../../../shared/Svgs';
import {
  bindMethods,
  setRef,
} from '../../../../shared/utilities/componentHelpers';
import {getGATags} from '../../../../shared/utilities/GAHelpers';
import {
  OPTIONS_TEMPLATE,
  QUESTION_TYPES,
  queryLocationSearch,
  mutatePersonUGC,
} from '../../../../redux/ugcHelper';
import classNames from 'classnames';
import questions from './data/questions';
import ls from 'local-storage';

const {Button, TextInput} = FormControls;

export class Questionnaire extends React.Component {
  static propTypes = {
    queryLocationSearch: React.PropTypes.func,
    mutatePersonUGC: React.PropTypes.func,
    personStore: React.PropTypes.object,
  };

  constructor(props) {
    super(props);

    const person = _.get(props, 'personStore.person') || {};
    const {city, state} = person.locationDisplay || {};

    this.personId = person.personId;
    this.obituaryId = _.get(person, 'obitSources.displayText');
    this.defaultQuestionId = 'ugc_did_you_know';
    this.currentQuestionId = this.defaultQuestionId;
    this.currentIndex = 0;

    this.location = _.compact([city, state]).join(', ');
    this.name = getName(person.name);
    this.cityState = 'State';
    this.questions = questions();
    this.options = null;

    this.state = {
      currentQuestion: this.getQuestion(),
      currentStep: 0,
      dayField: '',
      entryField: '',
      monthField: '',
      totalSteps: 0,
      isClosed: false,
      isFetching: false,
      isPendingFetch: false,
      isSubmitDisabled: true,
      searchStringSuggestion: '',
      showSuggestion: false,
      showThankYou: false,
      showToolTip: false,
      yearField: '',
    };

    this.questionType = this.state.currentQuestion.type;
    this.thankYouWaitTime = 3000;

    this.locations = {
      city: {
        id: null,
        name: null,
      },
      state: {
        id: null,
        name: null,
        code: null,
      },
    };

    this.isClient = typeof window !== 'undefined';
    this.isDisabled = this.isClient ? this.getLocalStorage() : false;

    this.entryField = null;
    this.setRefEntryField = _.partial(setRef, _, 'entryField', this);
    this.dayField = null;
    this.setRefDayField = _.partial(setRef, _, 'dayField', this);
    this.monthField = null;
    this.setRefMonthField = _.partial(setRef, _, 'monthField', this);
    this.yearField = null;
    this.setRefYearField = _.partial(setRef, _, 'yearField', this);

    bindMethods(this, [
      'checkQuestionType',
      'doCloseModule',
      'fetchSearchResults',
      'getComponentStyles',
      'getQuestion',
      'getTemplatizedQuestionString',
      'handleClick',
      'handleInputChange',
      'handleKeyDown',
      'handleKeyUp',
      'handleShowTooltip',
      'handleSuggestionClick',
      'showNextQuestion',
      'showThankYou',
      'submit',
      'updateSearchResults',
    ]);
  }

  componentDidMount() {
    if (_.get(this.props, 'personStore.person.clearStorage')) {
      this.setLocalStorage(true);
      this.isDisabled = true;
    }

    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillReceiveProps(nextProps) {
    const result = _.get(nextProps, 'personStore.locationSearch');

    this.updateSearchResults(result);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  /**
   * updates search result
   * @param  {object} result  result object from solr
   * @return {undefined}      returns nothing
   */
  updateSearchResults(result) {
    const nextState = {isFetching: false};

    if (_.get(result, 'totalResults')) {
      const locations = {
        city: {
          id: _.get(result, 'city.id', ''),
          name: _.get(result, 'city.name', ''),
        },
        state: {
          id: _.get(result, 'state.id', ''),
          name: _.get(result, 'state.name', ''),
          code: _.get(result, 'state.code', ''),
        },
      };

      nextState.searchStringSuggestion = this.getSearchStringSuggestion(
        locations,
        this.cityState === 'State'
      );

      const latestSuggestion = nextState.searchStringSuggestion.toLowerCase();
      const latestValue = this.state.entryField.toLowerCase();

      nextState.showSuggestion =
        latestSuggestion.indexOf(latestValue) !== -1 && latestValue !== '';

      this.locations = locations;
    }

    if (this.state.isPendingFetch) {
      nextState.isPendingFetch = false;
      this.setState(nextState, () => {
        this.fetchSearchResults();
      });
    } else {
      this.setState(nextState);
    }
  }

  /**
   * formats suggestion
   * @param  {object} locations   locations object
   * @param  {Boolean} stateOnly  city vs state flag
   * @return {string}             formatted suggestion
   */
  getSearchStringSuggestion(locations, stateOnly) {
    const isCity = !stateOnly;
    const locationString = [];
    const {city, state} = locations;
    const {name: cityName} = city;
    const {name: stateName} = state;
    let hasSuggestion = true;

    if (cityName && !stateOnly) {
      locationString.push(cityName);
      locationString.push(', ');
    }

    if (isCity && !cityName) {
      hasSuggestion = false;
    }

    locationString.push(stateName);

    return hasSuggestion ? locationString.join('') : '';
  }

  /**
   * closes module
   * @return {undefined} returns nothing
   */
  doCloseModule() {
    this.setState({isClosed: true});
  }

  /**
   * shows thank you screen
   * @return {undefined} returns nothing
   */
  showThankYou() {
    this.setState({showThankYou: true});

    setTimeout(this.doCloseModule, this.thankYouWaitTime);
  }

  /**
   * update currentIndex, moving process forward
   * @return {undefined} returns nothing
   */
  showNextQuestion() {
    const currentQuestion = this.getQuestion();

    this.questionType = currentQuestion.type;

    const {
      currentStep,
      totalSteps,
      searchStringSuggestion,
      showSuggestion,
    } = this.checkQuestionType();

    this.currentIndex++;
    this.setState(
      {
        currentQuestion,
        currentStep,
        totalSteps,
        entryField: '',
        searchStringSuggestion: searchStringSuggestion || '',
        showSuggestion: showSuggestion || false,
      },
      () => {
        this.focusTextField();
      }
    );
  }

  /**
   * focuses input field
   * @return {undefined} returns nothing
   */
  focusTextField() {
    const fields = [
      this.entryField,
      this.dayField,
      this.yearField,
      this.monthField,
    ];

    _.map(fields, field => {
      if (field) {
        const textArea = _.get(field, '_textInput', {});

        if (_.isFunction(textArea.focus)) {
          textArea.focus();
        }
      }
    });
  }

  /**
   * checks current question for data dependencies
   * @param  {object} question question object
   * @return {object}          describes dependency and fallback info
   */
  checkDependencies(question) {
    const dependencies = _.get(question, 'dependencies', {});
    const requirements = _.get(dependencies, 'required');
    const fallback = _.get(dependencies, 'fallback');
    let hasMetDependencies = true;

    if (requirements) {
      _.map(requirements.split(','), req => {
        if (!this[req]) {
          hasMetDependencies = false;
        }
      });
    }

    return {hasMetDependencies, fallback};
  }

  /**
   * sets current question
   * @param  {string} id  question id
   * @return {object}     current question object
   */
  getQuestion(id) {
    const currentQuestion = _.cloneDeep(
      _.get(this.questions, `${id ? id : this.currentQuestionId}`)
    );
    const {hasMetDependencies, fallback} = this.checkDependencies(
      currentQuestion
    );

    if (hasMetDependencies === true) {
      currentQuestion.question = _.template(currentQuestion.question);
      currentQuestion.options = _.merge(
        _.cloneDeep(OPTIONS_TEMPLATE),
        currentQuestion.options
      );

      this.options = _.sortBy(
        _.partition(currentQuestion.options, 'position')[0],
        ['position']
      );
      this.questionType = currentQuestion.type;

      return currentQuestion;
    }

    this.currentQuestionId = fallback;
    return this.getQuestion();
  }

  /**
   * gets fully formatted question for display
   * @param  {object} question question object
   * @return {string}          templatized question string
   */
  getTemplatizedQuestionString(question) {
    return question({
      cityState: this.cityState,
      location: this.location,
      name: this.name,
    });
  }

  /**
   * gets main styles
   * @return {Object} classes based on conditions
   */
  getComponentStyles() {
    const conditionalClasses = {};

    conditionalClasses[styles.isClosed] = this.state.isClosed;
    conditionalClasses[styles.isOpen] = !this.state.isClosed;
    conditionalClasses[styles.thankYou] = this.state.showThankYou;

    return classNames(styles.Questionnaire, conditionalClasses);
  }

  /**
   * hover handler for tooltip
   * @param  {Boolean} val  to show, or not to show
   * @return {undefined}    returns nothing
   */
  handleShowTooltip(val) {
    if (val !== this.state.showToolTip) {
      this.setState({showToolTip: val});
    }
  }

  /**
   * checks for mulit-stage questions. sets step count and suggestions accordingly
   * @param  {string} action user action string
   * @return {object}        object of new/needed state variables
   */
  checkQuestionType(action) {
    const typeRules = QUESTION_TYPES[this.questionType];
    const typeSteps = _.size(_.get(typeRules, 'group', []));
    const newState = {};

    if (typeSteps && action !== 'close') {
      const {currentStep, totalSteps} = this.state;

      if (totalSteps === 0) {
        newState.totalSteps = typeSteps;
        newState.currentStep = 0;
      } else if (currentStep < typeSteps - 1) {
        newState.totalSteps = totalSteps;
        newState.currentStep = currentStep + 1;
      } else {
        newState.totalSteps = 0;
        newState.currentStep = 0;
      }

      this.cityState = newState.currentStep === 0 ? 'State' : 'City';

      newState.searchStringSuggestion = this.getSearchStringSuggestion(
        this.locations,
        this.cityState === 'State'
      );
      newState.showSuggestion = newState.searchStringSuggestion || false;
    }
    return newState;
  }

  /**
   * Click Handler
   * @param  {string} action action descriptor
   * @return {undefined}     returns nothing
   */
  handleClick(action) {
    const eventCategory = 'bypage_person';
    const eventLabel = `ugc_prompt_${this.currentIndex + 1}`;
    const tracking = {
      eventCategory,
      eventLabel,
      eventAction: this.currentQuestionId,
    };
    const value =
      {
        yes: {
          action: this.showNextQuestion,
          tracking: _.merge({eventValue: 1}, tracking),
        },
        no: {
          action: this.showNextQuestion,
          tracking: _.merge({eventValue: 1}, tracking),
        },
        skip: {
          action: this.showNextQuestion,
          tracking: _.merge({eventValue: 0}, tracking),
        },
        close: {
          action: this.doCloseModule,
          tracking: {eventCategory, eventLabel, eventValue: 3},
        },
      }[action] || null;

    if (value) {
      const {
        currentStep,
        totalSteps,
        searchStringSuggestion,
        showSuggestion,
      } = this.checkQuestionType(action);

      if (
        (currentStep || totalSteps) &&
        (action === 'yes' || action === 'no')
      ) {
        this.setState(
          {
            currentStep,
            totalSteps,
            entryField: '',
            searchStringSuggestion: searchStringSuggestion || '',
            showSuggestion: showSuggestion || false,
            isSubmitDisabled: true,
          },
          () => {
            this.focusTextField();
          }
        );
      } else {
        getGATags(value.tracking);

        const options = _.get(this.state, 'currentQuestion.options');
        const nextQuestionId =
          _.get(options, 'globalAction') || _.get(options, `${action}.action`);

        this.submit(action === 'yes');
        this.setLocalStorage();

        if (nextQuestionId) {
          this.currentQuestionId = nextQuestionId;
          this.setState(
            {
              totalSteps: 0,
              isSubmitDisabled: true,
              dayField: '',
              monthField: '',
              yearField: '',
            },
            () => {
              value.action();
            }
          );
        } else {
          this.showThankYou();
        }
      }
    }
  }

  /**
   * fetches solr search results
   * @return {undefined} returns nothing
   */
  fetchSearchResults() {
    const value = this.state.entryField.replace(/[^a-z ]+/gi, '');

    if (!this.state.isFetching && value && value.length >= 2) {
      this.props.queryLocationSearch({
        location: value,
        stateId: this.cityState === 'State' ? '' : this.locations.state.id,
      });
      this.setState({isFetching: true});
    } else {
      this.setState({isPendingFetch: true});
    }
  }

  /**
   * checks if submit button should be enabled
   * @param  {string} value value of text field
   * @return {Boolean}      enabled value
   */
  checkEnableSubmit(value) {
    let disabled = true;

    if (_.isObject(value)) {
      const {dayField, monthField, yearField, fields} = value;
      let fieldsComplete = true;

      if (dayField.length !== fields.dayField.maxChars) {
        fieldsComplete = false;
      }
      if (monthField.length !== fields.monthField.maxChars) {
        fieldsComplete = false;
      }
      if (yearField.length !== fields.yearField.maxChars) {
        fieldsComplete = false;
      }
      disabled = !fieldsComplete;
    } else {
      disabled = !(value && value.length >= 2);
    }

    return disabled;
  }

  /**
   * submit/validate values
   * @param  {Boolean} value boolean value of validation questions
   * @return {undefined} returns nothing
   */
  submit(value) {
    const answerType = this.questionType;
    const isDefaultQuestion = this.currentQuestionId === this.defaultQuestionId;
    let answer = null;

    if (answerType === 'location') {
      const inputValue = this.state.entryField;
      const cityName = this.locations.city.name;
      const id = this.locations.city.id;

      if (inputValue === cityName) {
        answer = id;
      }
    } else if (answerType === 'validation' && !isDefaultQuestion) {
      answer = value;
    } else if (answerType === 'date') {
      const date = new Date(
        this.state.yearField,
        parseInt(this.state.monthField, 10) - 1,
        this.state.dayField
      );

      if (date.getTime()) {
        answer = moment(date).format('YYYY-MM-DD');
      }
    }

    if (answer) {
      this.props.mutatePersonUGC({
        personId: this.personId,
        obituaryId: _.head(this.obituaryId),
        characteristicCode: `pp_${this.currentQuestionId}`,
        answerType,
        answer,
      });
    }
  }

  /**
   * sets or resets local storage
   * @param   {Boolean} reset true to reset
   * @return  {undefined}     returns nothing
   */
  setLocalStorage(reset) {
    if (reset) {
      ls.clear();
    } else {
      ls.set(this.personId, true);
    }
  }

  /**
   * gets local storage value
   * @return {Boolean} value
   */
  getLocalStorage() {
    return ls.get(this.personId) || false;
  }

  /**
   * input change handler
   * @param  {event} e      onChange event
   * @param  {String} key   id key
   * @return {undefined}    returns nothing
   */
  handleInputChange(e, key) {
    const value = e.target.value;
    const stateObj = {};
    const fields = {
      dayField: {
        maxChars: 2,
      },
      monthField: {
        maxChars: 2,
      },
      yearField: {
        maxChars: 4,
      },
    };
    let testValue = null;

    if (key === 'entryField') {
      stateObj[key] = value;
      testValue = value;
      if (!value) {
        stateObj.showSuggestion = false;
      }
    } else {
      const numericValue = value.replace(/[^0-9]+/gi, '');
      const field = fields[key];

      if (
        (numericValue !== '' && numericValue.length <= field.maxChars) ||
        value === ''
      ) {
        stateObj[key] = numericValue;
        testValue = {
          dayField: this.state.dayField,
          monthField: this.state.monthField,
          yearField: this.state.yearField,
          fields,
        };
        testValue[key] = numericValue;
      }
    }

    stateObj.isSubmitDisabled = this.checkEnableSubmit(testValue);

    this.setState(stateObj, () => {
      if (value && key === 'entryField') {
        this.fetchSearchResults();
      }
    });
  }

  /**
   * input key up handler
   * @param  {event} e    onKeyUp event
   * @return {undefined}  returns nothing
   */
  handleKeyUp(e) {
    if (
      e.keyCode === 13 &&
      this.state.showSuggestion &&
      this.state.entryField
    ) {
      this.handleSuggestionClick();
    }
  }

  /**
   * keyDown handler for local storage reset
   * @param  {event} e    onKeyDown event
   * @return {undefined}  returns nothing
   */
  handleKeyDown(e) {
    const {altKey, code, shiftKey} = e;

    if (altKey && code === 'KeyC' && shiftKey) {
      this.setLocalStorage(true);
      window.location.reload(true);
    }
  }

  /**
   * click handler for search suggestion
   * @return {undefined} returns nothing
   */
  handleSuggestionClick() {
    const suggestion = this.state.searchStringSuggestion;
    const entry =
      this.cityState === 'State' ? suggestion : this.locations.city.name;

    this.setState(
      {
        entryField: entry,
        showSuggestion: false,
        isSubmitDisabled: this.checkEnableSubmit(entry),
      },
      () => {
        this.focusTextField();
      }
    );
  }

  /**
   * The Questionnaire component on the person page
   * @param   {Object}  props - passed down props
   * @return  {JSX}     Returns a Questionnaire
   */
  render() {
    const count = `${this.state.currentStep + 1} of ${this.state.totalSteps}`;

    return this.name && !this.isDisabled ? (
      <aside className={this.getComponentStyles()}>
        <div className={styles.topRightLockup}>
          <div
            className={styles.infoIcon}
            onMouseOut={_.partial(this.handleShowTooltip, false)}
            onMouseOver={_.partial(this.handleShowTooltip, true)}
          >
            <div
              className={styles.toolTip}
              style={{opacity: this.state.showToolTip ? 1 : 0}}
            >
              <div className={styles.arrow} />
              <p>{`Help us improve this page by providing information about ${
                this.name
              } to make this page more accurate and personalized.`}</p>
            </div>
            <InfoIcon />
          </div>
          <div
            className={styles.close}
            onClick={_.partial(this.handleClick, 'close')}
          >
            <CloseXIcon />
          </div>
        </div>
        <div className={styles.content}>
          {this.state.showThankYou ? (
            <div className={styles.thankYou}>
              <HeartIcon />
              <p className={styles.header}>Thank You</p>
              <p className={styles.body}>
                Your answers will help make this page more accurate.
              </p>
            </div>
          ) : (
            <div className={styles.question}>
              {this.questionType === 'location' ? (
                <span className={styles.count}>{count}</span>
              ) : null}
              <p>
                {this.getTemplatizedQuestionString(
                  this.state.currentQuestion.question
                )}
              </p>
              {this.questionType === 'location' ? (
                <div className={styles.location}>
                  <TextInput
                    handleChange={_.partial(
                      this.handleInputChange,
                      _,
                      'entryField'
                    )}
                    handleKeyUp={this.handleKeyUp}
                    name="entryField"
                    placeholder={`Type ${this.cityState} Name`}
                    ref={this.setRefEntryField}
                    type="text"
                    value={this.state.entryField}
                  />
                  {this.state.showSuggestion ? (
                    <aside
                      className={styles.suggestedMatch}
                      onClick={this.handleSuggestionClick}
                    >
                      <p>
                        <UGCSearchIcon />
                        {this.state.searchStringSuggestion}
                      </p>
                    </aside>
                  ) : null}
                </div>
              ) : null}
              {this.questionType === 'date' ? (
                <div className={styles.dateBlock}>
                  <TextInput
                    className={styles.month}
                    handleChange={_.partial(
                      this.handleInputChange,
                      _,
                      'monthField'
                    )}
                    name="monthField"
                    placeholder={'mm'}
                    ref={this.setRefMonthField}
                    type="tel"
                    value={this.state.monthField}
                  />
                  <TextInput
                    className={styles.day}
                    handleChange={_.partial(
                      this.handleInputChange,
                      _,
                      'dayField'
                    )}
                    id="day"
                    name="dayField"
                    placeholder={'dd'}
                    ref={this.setRefDayField}
                    type="tel"
                    value={this.state.dayField}
                  />
                  <TextInput
                    className={styles.year}
                    handleChange={_.partial(
                      this.handleInputChange,
                      _,
                      'yearField'
                    )}
                    id="year"
                    name="yearField"
                    placeholder={'yyyy'}
                    ref={this.setRefYearField}
                    type="tel"
                    value={this.state.yearField}
                  />
                </div>
              ) : null}
              <div className={styles.buttonGroup}>
                {this.options.map((option, index) =>
                  option.label ? (
                    <Button
                      btnType="primary"
                      className={styles.button}
                      disabled={
                        option.label === 'Submit' && this.state.isSubmitDisabled
                      }
                      handleClick={_.partial(this.handleClick, option.value)}
                      key={index}
                    >
                      {option.label}
                    </Button>
                  ) : null
                )}
              </div>
            </div>
          )}
        </div>
      </aside>
    ) : null;
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({personStore: _.get(state, 'personStore')});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  queryLocationSearch: searchParams => {
    dispatch(queryLocationSearch(searchParams));
  },
  mutatePersonUGC: mutationParams => {
    dispatch(mutatePersonUGC(mutationParams));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {withRef: true}
)(Questionnaire);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/Questionnaire/Questionnaire.js